module.exports = __webpack_public_path__ + "static/media/sayuwont.def5d278.mp3";